/* This file is autogenerated, see readme.md for instructions */
import EmptySvgIcon from '@bloomreach/banana-theme/icons/empty.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const EmptyIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <EmptySvgIcon />
    </Icon>
  );
});

EmptyIcon.displayName = 'EmptyIcon';

export default EmptyIcon;
